export default __webpack_public_path__ + "static/hero-image-e311f583c0e58f54ff50a9697cbc6452.png";